import { IForm } from '@/components/types'

export const modalConfig: IForm = {
  formItems: [
    {
      field: 'empNo',
      type: 'input',
      label: '员工编号',
      placeholder: '请输入员工编号',
      rules: { required: true, message: '员工编号是必传的', trigger: 'blur' }
    },
    {
      field: 'nickName',
      type: 'input',
      label: '昵称',
      placeholder: '请输入昵称',
      rules: { required: true, message: '昵称是必传的', trigger: 'blur' }
    },
    {
      field: 'realName',
      type: 'input',
      label: '真实姓名',
      placeholder: '请输入真实姓名',
      rules: { required: true, message: '真实姓名是必传的', trigger: 'blur' }
    },
    {
      field: 'empTag',
      type: 'select',
      label: '员工标签',
      placeholder: '请选择',
      clearable: true,
      options: [
        { title: '518', value: '0' },
        { title: '投教', value: '1' }
      ]
    },
    {
      field: 'isManager',
      type: 'select',
      label: '是否是经理',
      placeholder: '请选择',
      rules: { required: true, message: '是必传的', trigger: 'blur' },
      options: [
        { title: '经理', value: '1' },
        { title: '员工', value: '0' }
      ]
    },
    {
      field: 'deptId',
      type: 'select',
      label: '选择部门',
      placeholder: '请选择部门',
      rules: { required: true, message: '部门是必传的', trigger: 'blur' },
      options: []
    },
    {
      field: 'roleIds',
      type: 'select',
      multiple: true,
      label: '选择角色',
      placeholder: '请选择角色',
      rules: { required: true, message: '角色是必传的', trigger: 'blur' },
      options: []
    }
  ],
  colLayout: 24,
  itemStyle: {}
}
